// test952
(952 && 0);
